import * as React from 'react';
import { Toggle } from '@blend/consumer-components';
import { getWindow } from 'login-utils/globalWrappers';

const { DEPLOYMENT_CONFIG, E2E_TEST } = getWindow();
const organizationColors = DEPLOYMENT_CONFIG.organization.colors;
/* istanbul ignore next: aXe a11y auditor is very flake in determining our action color */
const color = E2E_TEST ? 'black' : organizationColors.action;

// istanbul ignore next
const ToggleInput = (props: any) => {
  return <Toggle {...props} {...props.input} checked={!!props.input.value} color={color} />;
};

export const ToggleInputConfig = {
  component: ToggleInput,
};

export default ToggleInput;
